import React from 'react';
import Intl from 'src/components/common/Intl';

function Currency() {
    return (
        <><Intl langKey="₹" /></>
    )
}

export default Currency